//NPM LIBRARIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, StandaloneSearchBox, InfoWindow } from '@react-google-maps/api'
import AUtextInput from '@gov.au/text-inputs';
import { AUlabel, AUformGroup } from '@gov.au/form';
import { AUfieldset, AUlegend } from '@gov.au/form';
//COMPONENTS AND UTILITIES
import { validateAnswerHasValue } from '../../CASAForm/Utilities';


class GoogleMapAddressPicker extends Component {

    constructor(props) {
        super(props);

        let answer = {
            value: '',
            subAnswers: {
                lngLat: { lat: -35.342305, lng: 149.083739 }
            }
        };
        let errorMessage = ''
        let currentMarker = null

        if (props.existingAnswer) {
            answer = props.existingAnswer
            currentMarker = props.existingAnswer.subAnswers.lngLat

        } else if (props.initvalue) {
            answer.subAnswers.lngLat = props.initvalue
        }

        if (props.mandatory) {
            errorMessage = validateAnswerHasValue(props.type, answer, props.mandatory);
        }

        this.state = {
            scriptLoaded: false,
            center: { lat: -35.342305, lng: 149.083739 },
            currentMarker: currentMarker,
            marker: null,
            google: null,
            answer: answer,
            errorMessage: errorMessage
        }

        this.searchBox = React.createRef();
        this.googleMap = React.createRef();

        this.setLocationMarker = this.setLocationMarker.bind(this);
        this.onPlacesChanged = this.onPlacesChanged.bind(this);
        this.onSearchLoad = this.onSearchLoad.bind(this);
        this.onMapLoad = this.onMapLoad.bind(this);
        this.onMarkerLoad = this.onMarkerLoad.bind(this);
    }

    handleScriptLoad() {
        this.setState({ scriptLoaded: true })
    }

    setLocationMarker(e) {
        let currentLocation = { lat: e.latLng.lat(), lng: e.latLng.lng() }

        if (this.googleMap) {
            this.googleMap.panTo(currentLocation)

            this.setState({
                currentMarker: currentLocation
            });
        }

        let url = 'https://www.google.com/maps/search/?api=1&query='

        let answer = {
            value: url + e.latLng.lat() + ',' + e.latLng.lng(),
            subAnswers: {
                lngLat: currentLocation,
            }
        }

        let errorMessage = validateAnswerHasValue(this.props.type, answer, this.props.mandatory);

        this.setState({
            answer: answer,
            errorMessage: errorMessage
        });

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: answer
        }

        this.props.returnQuestionData(questionObject);
    }

    onPlacesChanged() {

        let currentPlace = this.searchBox.getPlaces()[0]
        let currentLocation = { lat: currentPlace.geometry.location.lat(), lng: currentPlace.geometry.location.lng() }

        let url = 'https://www.google.com/maps/search/?api=1&query='

        if (this.googleMap) {
            this.googleMap.panTo(currentLocation)

            this.setState({
                currentMarker: currentLocation
            });
        }

        let answer = {
            value: url + currentLocation.lat + ',' + currentLocation.lng,
            subAnswers: {
                lngLat: currentLocation,
            }
        }

        let errorMessage = validateAnswerHasValue(this.props.type, answer, this.props.mandatory);

        this.setState({
            answer: answer,
            errorMessage: errorMessage
        });

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: answer
        }

        this.props.returnQuestionData(questionObject);
    }

    onSearchLoad(ref) {
        this.searchBox = ref
    }

    onMapLoad(ref) {
        this.googleMap = ref;
        this.setState({
            google: window.google
        })
    }

    onMarkerLoad(marker) {
        this.setState({
            marker: marker
        })
    }

    render() {
        return (
            <div className="au-form-group casa-inline-form-group">
                <AUfieldset>
                    <AUlegend>
                        <h3 className="au-display-sm">{this.props.label}</h3>
                        <span className="au-hint-text">{this.props.hintText}</span>
                    </AUlegend>
                    <AUformGroup
                        className="margin-none"
                        status={this.props.getStatus(this.state.errorMessage)}>
                        <AUformGroup
                            className="margin-none">
                            <AUlabel text="Address" htmlFor="addressSearch" />
                            <StandaloneSearchBox
                                onLoad={this.onSearchLoad}
                                onPlacesChanged={this.onPlacesChanged}
                                bounds={this.state.google ? new this.state.google.maps.LatLngBounds(
                                    new this.state.google.maps.LatLng(-43.6345972634, 113.338953078),
                                    new this.state.google.maps.LatLng(-10.6681857235, 153.569469029)
                                ) : null} >
                                <AUtextInput
                                    type="text"
                                    id="addressSearch"
                                    block
                                    name="addressSearch"
                                    placeholder="Enter address" />
                            </StandaloneSearchBox>
                        </AUformGroup>
                        <AUformGroup>
                            <GoogleMap
                                id='example-map'
                                onLoad={this.onMapLoad}
                                mapContainerStyle={{ height: "400px" }}
                                zoom={16}
                                center={this.state.center}
                                onClick={this.setLocationMarker}
                                clickableIcons={false}
                                options={{
                                    fullscreenControl: false,
                                    streetViewControl: false,
                                    gestureHandling: "greedy",
                                    mapTypeControlOptions: {
                                        mapTypeIds: ['roadmap', 'satellite']
                                    },
                                    componentRestrictions: {
                                        country: "AU"
                                    }
                                }}>
                                {this.state.currentMarker &&
                                    <Marker
                                        onLoad={this.onMarkerLoad}
                                        position={this.state.currentMarker} />
                                }
                                {this.state.marker &&
                                    <InfoWindow
                                        anchor={this.state.marker}>
                                        {
                                            <div className="infowindow-container">
                                                <h1>Fireworks Location</h1>
                                                <div className="inner-content">
                                                    <p>You have selected this location<br /> for your fireworks event</p>
                                                    <p>{parseFloat(this.state.currentMarker.lat.toFixed(6)) + ", " + parseFloat(this.state.currentMarker.lng).toFixed(6)}</p>
                                                </div>
                                            </div>
                                        }
                                    </InfoWindow>
                                }
                            </GoogleMap>
                        </AUformGroup>
                        {this.props.createErrorMessage(this.state.errorMessage)}
                    </AUformGroup>
                </AUfieldset>
            </div>
        )
    }
}

GoogleMapAddressPicker.propTypes = {
    id: PropTypes.string.isRequired,
    stepid: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    hintText: PropTypes.string.isRequired,
    initvalue: PropTypes.string,
    mandatory: PropTypes.bool.isRequired,
    enabled: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    type: PropTypes.string,
    createErrorMessage: PropTypes.func,
    validate: PropTypes.string,
    returnQuestionData: PropTypes.func,
    existingAnswer: PropTypes.object,
    getStatus: PropTypes.func
}

GoogleMapAddressPicker.defaultProps = {
    mandatory: true,
    enabled: true,
    show: true,
    hintText: "Enter your address or click on the map below"
};

export default GoogleMapAddressPicker

